import type { ComponentProps } from "react";
import type { Lead } from "../../../../../client";
import { Button } from "../../../../../components/buttons/button";
import { useSemanticMatchWithProgress } from "../../../../../services/organtization/semantic-match";
import { AssignmentAccordionPanel } from "./AssignmentAccordionPanel";
import { SemanticMatchResultsList } from "./SemanticMatchResultsList";

type AssignmentPanelProps = ComponentProps<typeof AssignmentAccordionPanel>;

interface Props extends AssignmentPanelProps {
  leadId: string;
  childLeads?: Lead[];
  hideProfileList?: boolean;
  onArchive?: () => void;
}

export const AssignmentWithMatchPanel = ({ leadId, childLeads, hideProfileList, onArchive, ...panelProps }: Props) => {
  const { run: runMatch, isMatching, progress } = useSemanticMatchWithProgress(
    panelProps.organizationId,
    leadId,
  );

  if (hideProfileList) {
    return <AssignmentAccordionPanel {...panelProps} onArchive={onArchive} />;
  }

  return (
    <div className="flex gap-6">
      <div className="w-1/3 min-w-0 overflow-x-hidden overflow-y-auto max-h-[95vh]">
        <AssignmentAccordionPanel {...panelProps} onArchive={onArchive} />
      </div>
      <div className="w-2/3 min-w-0 bg-white border border-gray-3 rounded-2xl p-5 flex flex-col gap-4">
        <div className="flex flex-row items-start gap-3">
          <span className="font-bold text-lg">2.</span>
          <div className="flex flex-col flex-1 min-w-0">
            <span className="font-bold text-lg">Create profile versions</span>
            <span className="text-sm text-gray-6">
              Make your profiles client-ready. Automatically optimized and
              enriched for every new lead.
            </span>
          </div>
          {!isMatching && (
            <Button variant="magic" onClick={runMatch} className="shrink-0">
              Run matching
            </Button>
          )}
        </div>
        <SemanticMatchResultsList
          organizationId={panelProps.organizationId}
          leadId={leadId}
          onMutateLead={panelProps.onMutateLead}
          childLeads={childLeads}
          isParsingAssignment={panelProps.disabled}
          hasAssignment={!!panelProps.lead?.parsedAssignmentData}
          hideAction
          externalIsMatching={isMatching}
          matchProgress={isMatching ? progress : undefined}
        />
      </div>
    </div>
  );
};

AssignmentWithMatchPanel.displayName = "AssignmentWithMatchPanel";
